<template>
  <div class="">
    <nav-bar :navigationIndex="1" @customEvent="parentMethod" />
    <div class="main_bg">
      <div class="first_main_box">
        <div class="column_title_box flex_center flex_column w_1280 no-select">
          <div class="title_name">根据自身需求，选择适合您的方式</div>
          <div class="title_txt">请登录后获取适合您的方案</div>
        </div>

        <div class="first_list flex_between w_1280">
          <div class="first_box first_bg_one">
            <div class="first_left_title flex_between">
              产品检索器 <span class="color_238AFE fz16">登录了解更多</span>
            </div>
            <div class="fz18">
              根据您的产品指标需求，为您提供准确的产品。若不满足您的定制化需求，可通过混配计算器为您生成最佳的石油焦混配方案
            </div>

            <div class="product_type_box fz18 flex">
              <span class="" style="width: 83px;">
                产品类型:
              </span>

              <el-select v-model="productTypeId" class="ml10" style="width: 443px;color: #238AFE;" placeholder="请选择"
                size="small">
                <el-option v-for="item in productTypeListInfo" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </div>
            <div class="target_list flex">
              <div class="target_box" v-for="item in listGlobalInfo" :key="item.id">
                <div class="target_name fz18 flex">
                  <img :src="item.logo" alt="" />{{ item.name }}
                </div>
                <div class="target_input2 flex">
                  <input type="number" v-model="item.value" placeholder="请输入" @change="smallValue(item)" />
                  <span class="separator">~</span> <!-- 新增 ~ 符号的包裹元素 -->
                  <input type="number" v-model="item.maxValue" placeholder="请输入" @change="bigValue(item)" />
                  <span class="unit_box fz18 color_238AFE">{{ item.unit }}</span>
                </div>
              </div>
            </div>

            <div class="search_btn fz20 color_fff flex_center cursor" @click="retrieveImmediately">
              立即检索
            </div>
          </div>
          <div class="first_box first_bg_two">
            <div class="first_left_title flex_between">
              混配计算器 <span class="color_238AFE fz16">登录获取方案</span>
            </div>
            <div class="fz18 first_left_text">
              可以根据您的产品指标需求，从全网挂单、炼厂生产工艺历史指标和历史成交数据为您生成最佳的石油焦混配方案
            </div>

            <div class="target_list flex">
              <div class="target_box" v-for="item in listGlobalInfo" :key="item.id">
                <div class="target_name fz18 flex">
                  <img :src="item.logo" alt="" />{{ item.name }}
                </div>
                <div class="target_input flex">
                  <input type="text" placeholder="请输入" /> <span class="unit_box fz18 color_238AFE">{{ item.unit
                    }}</span>
                </div>
              </div>
            </div>

            <div class="search_btn_two fz20 color_fff flex_center cursor">
              配料计算
            </div>
          </div>
        </div>
      </div>

      <div class="second_main_box">
        <div class="column_title_box flex_center flex_column w_1280 no-select">
          <div class="title_name">供需大厅</div>
          <div class="title_txt">一站式供需对接交流大平台</div>
        </div>

        <div class="second_list flex_between w_1280">
          <div class="second_box">
            <div class="second_top_box flex_center flex_column color_fff second_bg_one">
              <!-- <div class="fz34 fw800">
                供应市场
              </div>
              <div class="fz18">
                汇聚海量优质供应资源集散地
              </div> -->
            </div>
            <div class="market_top bg_238AFE flex color_fff fz18">
              <div class="market_box_one flex_center border_right_CCDDFE padding12">日期</div>
              <div class="market_box_two flex_center border_right_CCDDFE padding12">品名类型</div>
              <div class="market_box_three flex_center border_right_CCDDFE padding12">重点指标</div>
              <div class="market_box_four flex_center border_right_CCDDFE padding12">地区</div>
              <!--              <div class="market_box_five flex_center border_right_CCDDFE padding12">价格</div>-->
              <div class="market_box_six flex_center">价格</div>
            </div>
            <div class="market_list" v-if="supplyMarketList.data.length > 0">
              <div class="market_top bg_fff fz16 cursor border_top_CCDDFE" :class="index % 2 != 0 ? 'bg_F9FBFF' : ''"
                @click="goDetail(item, 'xs')" v-for="(item, index) in supplyMarketList.data" :key="item.id">
                <div class="market_box_one flex_center border_right_CCDDFE padding10">
                  {{ item.createTime }}</div>
                <div class="market_box_two flex_center border_right_CCDDFE padding10">
                  {{ item.productTypeName }}</div>
                <div class="market_box_three flex_center border_right_CCDDFE padding10">
                  {{ item.propertyValue }}</div>
                <div class="market_box_four flex_center border_right_CCDDFE padding10">
                  {{ item.zoneName }}</div>
                <!--                <div class="market_box_five flex_center border_right_CCDDFE padding10">-->
                <!--                  {{ item.dealMoneySingle }}</div>-->
                <div class="market_box_six flex_center padding10"
                  :class="['market_six_D10000', 'market_six_09A601', ''][item.rateFlag]">{{ item.dealMoneySingle }}
                  <img v-if="item.rateFlag == 0" src="@/assets/images/riseIcon.png" alt="" /><img
                    v-if="item.rateFlag == 1" src="@/assets/images/declineIcon.png" alt="" />
                </div>
              </div>
            </div>
            <div class="market_list flex_center" v-else><img src="@/assets/images/noData.png" alt="" />
            </div>
          </div>
          <div class="second_box">
            <div class="second_top_box flex_center flex_column color_fff second_bg_two">
              <!-- <div class="fz34 fw800">
                需求市场
              </div>
              <div class="fz18">
                精准定位多元需求匹配中枢
              </div> -->
            </div>

            <div class="market_top bg_F34B4B flex color_fff fz18">
              <div class="market_box_one flex_center border_right_CCDDFE padding12">日期</div>
              <div class="market_box_two flex_center border_right_CCDDFE padding12">品名类型</div>
              <div class="market_box_three flex_center border_right_CCDDFE padding12">重点指标</div>
              <div class="market_box_four flex_center border_right_CCDDFE padding12">地区</div>
              <!--              <div class="market_box_five flex_center border_right_CCDDFE padding12">价格</div>-->
              <div class="market_box_six flex_center">价格</div>
            </div>
            <div class="market_list" v-if="demandMarketList.data.length > 0">
              <div class="market_top border_top_CCDDFE bg_fff fz16" :class="index % 2 != 0 ? 'bg_FEF8F1' : ''"
                @click="goDetail(item, 'cg')" v-for="(item, index) in demandMarketList.data" :key="item.id">
                <div class="market_box_one flex_center border_right_CCDDFE  padding10">{{ item.createTime }}</div>
                <div class="market_box_two flex_center border_right_CCDDFE  padding10">{{ item.productTypeName }}</div>
                <div class="market_box_three flex_center border_right_CCDDFE  padding10">{{ item.propertyValue }}</div>
                <div class="market_box_four flex_center border_right_CCDDFE  padding10">{{ item.zoneName }}</div>
                <!--                <div class="market_box_five flex_center border_right_CCDDFE  padding10">{{ item.dealMoneySingle }}</div>-->
                <div class="market_box_six flex_center  padding10"
                  :class="['market_six_D10000', 'market_six_09A601', ''][item.rateFlag]">{{ item.dealMoneySingle }}<img
                    v-if="item.rateFlag == 0" src="@/assets/images/riseIcon.png" alt="" /><img v-if="item.rateFlag == 1"
                    src="@/assets/images/declineIcon.png" alt="" /></div>
              </div>

            </div>
            <div class="market_list flex_center" v-else><img src="@/assets/images/noData.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-bar></bottom-bar>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted, getCurrentInstance } from "vue"
import { useRouter } from 'vue-router';

const router = useRouter();
onMounted(() => {
  // 组件挂载后执行的代码
  // getSupplyMarket();
  // getProductTypeList();
  // getListGlobal();
});

const isLogin = ref(false);

// 父组件的方法
const parentMethod = (type) => {
  console.log('父组件方法被调用', type);
  isLogin.value = type;
  // 登录后重新调用接口
  getSupplyMarket();
  getProductTypeList();
  getListGlobal();
};
const { proxy } = getCurrentInstance();

import { supplyMarket, demandMarket, productTypeList, listGlobal } from "@/utils/homeApi";


const supplyMarketList = ref({
  data: []
});
const demandMarketList = ref({
  data: []
});
const listGlobalInfo = ref([]);
const productTypeListInfo = ref([]);
const newlistGlobalInfo = ref([]);

const productTypeId = ref('')

const smallValue = (item) => {
  if (item.maxValue == '') {
    return;
  }
  if (Number(item.value) > Number(item.maxValue)) {
    item.value = '';
  }
};

const bigValue = (item) => {
  if (item.value == '') {
    return;
  }
  if (Number(item.value) > Number(item.maxValue)) {
    item.maxValue = '';
  }
};

const retrieveImmediately = async () => {
  // newlistGlobalInfo.value = []
  // listGlobalInfo.value.forEach((ele, index) => {
  //   if (ele.value != '') {
  //     newlistGlobalInfo.value.push(ele)
  //   }
  // })
  getSupplyMarket();
  // listGlobalInfo.value.push({
  //       code:ele.code,
  //       name:ele.name,
  //       unit:ele.unit,
  //       value:'',
  //     })
};
const getSupplyMarket = async () => {
  console.log('newlistGlobalInfo.value', listGlobalInfo.value);
  let propertyList = [];
  let propertyBetweenList = [];
  listGlobalInfo.value.forEach((ele, index) => {
    if (ele.value != '' && ele.maxValue != '') {
      propertyBetweenList.push({
        code: ele.code,
        name: ele.name,
        unit: ele.unit,
        value: ele.value,
        maxValue: ele.maxValue
      })
    } else {
      propertyList.push({
        code: ele.code,
        name: ele.name,
        unit: ele.unit,
        value: ele.value != '' ? ele.value : ele.maxValue,
      })
    }
  })
  let res1 = await supplyMarket({
    productTypeId: productTypeId.value,
    propertyList: propertyList,
    propertyBetweenList: propertyBetweenList
  });
  if (res1.code == 200) {
    supplyMarketList.value = res1.data;
  }

  let res2 = await demandMarket({
    productTypeId: productTypeId.value,
    propertyList: propertyList,
    propertyBetweenList: propertyBetweenList
  });
  if (res2.code == 200) {
    demandMarketList.value = res2.data;
  }
  // proxy.$message({
  //   message: '这是一条全局配置后的消息',
  //   type: 'success'
  // });
};

// 首页基本信息列表
const getProductTypeList = async () => {
  let res4 = await productTypeList();
  if (res4.code == 200) {
    productTypeListInfo.value = res4.data;
  }
};

const getListGlobal = async () => {
  let res = await listGlobal();
  if (res.code == 200) {
    // listGlobalInfo.value = res.data;
    res.data.forEach((ele) => {
      listGlobalInfo.value.push({
        code: ele.code,
        name: ele.name,
        unit: ele.unit,
        value: '',
        maxValue: '',
        logo: ele.logo
      })
    })
  }
};

// 查看产品详情
const goDetail = (item, marketType) => {
  if (isLogin.value) {
    router.push({
      path: '/listDetails',
      query: {
        id: item.id,
        marketType: marketType
      }
    });
  } else {
    proxy.$message({
      message: '登录后才能查看详情！',
      type: 'warning'
    });
  }

};

</script>
<style lang="scss" scoped>
.column_title_box {
  padding-top: 150px;
}

.title_name {
  font-size: 48px;
  font-weight: 600;
  letter-spacing: 5px;
}

.title_txt {
  font-size: 20px;
  font-weight: bold;
}

.main_bg {
  background: url("@/assets/images/dailyJiaoYiBg.png") no-repeat center;
  background-size: 100% 100%;
}

.first_main_box {}

.first_list {
  margin-top: 82px;
}

.first_box {
  width: 535px;
  // height: 520px;
  background: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 0 4px 2px rgba(51, 51, 51, 0.2);
  padding: 47px 39px 36px 56px;
}

.first_bg_one {
  background: url("@/assets/images/searchBg.png") no-repeat bottom;
  background-size: cover;
}

.first_bg_two {
  background: url("@/assets/images/compoundBg.png") no-repeat bottom;
  background-size: cover;
}

.first_left_title {
  font-size: 34px;
  margin-bottom: 27px;
}

.first_left_text {
  margin-bottom: 50px;
}

.product_type_box {
  margin-top: 30px;
}

/* 修改 el-select 输入框的背景颜色和边框颜色 */
:deep .el-select__wrapper {
  border: 1px solid #238AFE;
  height: 28px;

}

:deep .el-icon {
  color: #238AFE;
}

.target_list {
  width: 600px;
  flex-wrap: wrap;
  margin-top: 24px;
}

.target_box {
  margin-right: 51px;
  margin-bottom: 20px;
}

.target_name img {
  width: 22px;
  height: 22px;
  object-fit: cover;
  margin-right: 5px;
}

.target_input {
  padding: 5px 9px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #238AFE;
  margin-top: 5px;
}

.target_input input {
  width: 125px;
  height: 20px;
  margin-top: 5px;
  margin: 0;
  padding: 0;
  padding-left: 5px;
  // margin-right: 10px;
  border: none;
  outline: none;
  color: #238AFE;
}

.target_input2 {
  padding: 5px 9px 5px 0px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #238AFE;
  margin-top: 5px;
}

.target_input2 input {
  text-align: center;
  width: 60px;
  height: 20px;
  margin-top: 5px;
  margin: 0;
  padding: 0;
  padding-left: 5px;
  border: none;
  outline: none;
  color: #238AFE;
}

.unit_box {
  width: 90px;
  text-align: center;
}

.search_btn {
  width: 281px;
  height: 54px;
  background: #238AFE;
  border-radius: 4px;
  margin-top: 5px;
}

.search_btn_two {
  width: 281px;
  height: 54px;
  background: #238AFE;
  border-radius: 4px;
  margin-top: 35px;
}

.second_list {
  margin-top: 82px;
  padding-bottom: 150px;
}

.second_box {
  width: 630px;
  box-shadow: 0 0 2px 2px rgba(51, 51, 51, 0.2);
  border-radius: 8px;
}

.second_bg_one {
  background: url("@/assets/images/supplyTopBg.png") no-repeat center;
  background-size: 100% 100%;
}

.second_bg_two {
  background: url("@/assets/images/demandTopBg.png") no-repeat center;
  background-size: 100% 100%;
}

.second_top_box {
  width: 100%;
  height: 130px;
  background-color: #238AFE;
  border-radius: 8px 8px 0 0;
}

.market_top {
  display: flex;
}

.padding12 {
  padding: 12px 5px;
}

.padding10 {
  padding: 10px 5px;
}

.border_right_CCDDFE {
  border-right: 1px solid #CCDDFE;
}

.border_top_CCDDFE {
  border-top: 1px solid #CCDDFE;
}

.border_right_FFEFDD {
  border-right: 1px solid #FFEFDD;
}

.border_top_FFEFDD {
  border-top: 1px solid #FFEFDD;
}

.market_box_one {
  width: 105px;
  min-height: 100%;
}

.market_box_two {
  width: 101px;
  min-height: 100%;
}

.market_box_three {
  width: 200px;
  min-height: 100%;
}

.market_box_four {
  width: 80px;
  min-height: 100%;
}

.market_box_five {
  width: 100px;
  min-height: 100%;
}

.market_box_six {
  width: 77px;
  flex: 1;
  min-height: 100%;
}

.market_six_D10000 {
  color: #D10000;
}

.market_six_09A601 {
  color: #09A601;
}

.market_list {
  height: 645px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none; // 滚动条隐藏
  }
}

.no-select {
  user-select: none;
  /* 禁止文本选择 */
  pointer-events: none;
  /* 禁止鼠标事件（无法点击、拖动等） */
  -webkit-user-drag: none;
  /* 禁止 WebKit 浏览器拖动 */
  cursor: default;
  /* 更改鼠标样式，避免误导 */
}
</style>
